<template>
  <div class="tiktok-analytics-public-chart-follower">
    <div class="message message-info" v-if="isEmpty">データがありません。</div>
    <div class="div" v-else>
      <div class="graph-header-container">
        <div
          class="mb-x2"
          :class="{ 'graph-highlight-text': campaignStatusText === '最終データ取得待ち' }"
          layout
          layout-align="start-center"
        >
          {{ campaignStatusText }}
        </div>
        <div class="mb-x2" layout layout-align="end-center"></div>
        <el-tooltip placement="top" content="CSVダウンロード">
          <CsvDownload :download="downloadCsv" text=""></CsvDownload>
        </el-tooltip>
      </div>
      <AnalyticsChartDoughnut
        :data="trafficSource"
        :chartStyles="chartStyles"
        :height="450"
        :isTikTok="true"
      ></AnalyticsChartDoughnut>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.graph-highlight-text {
  color: #26a69a;
}

.graph-header-container {
  display: flex;
  justify-content: space-between;
}
</style>

<script lang="ts">
import { mapState } from 'pinia'
import { defineComponent } from 'vue'

import AnalyticsChartDoughnut from '@/client/components/_atoms/analytics_chart_doughnut'
import CsvDownload from '@/client/components/_atoms/csv_download'
import { CAMPAIGN_STATUS } from '@/client/constant'
import { useTikTokAnalyticsPublicStore } from '@/client/store/useTikTokAnalyticsPublicStore'

export default defineComponent({
  components: {
    CsvDownload,
    AnalyticsChartDoughnut
  },
  data() {
    return {
      chartStyles: {
        margin: '0 auto'
      }
    }
  },
  computed: {
    ...mapState(useTikTokAnalyticsPublicStore, {
      trafficSource: state => state.trafficSource,
      campaign: state => state.campaign
    }),
    isEmpty() {
      return this.trafficSource.every(v => v.count === 0)
    },
    campaignStatusText() {
      if (this.campaign?.status === CAMPAIGN_STATUS.DURING_FINAL_COLLECTION) {
        return '最終データ取得待ち'
      }

      if (this.campaign?.status === CAMPAIGN_STATUS.COLLECTION_COMPLETED) {
        return '集計完了'
      }

      return '開催中、24~48時間ごとに更新されます。'
    }
  },
  methods: {
    downloadCsv() {
      const filename = `${this.campaign?.title}_トラフィックソース`
      const data: (string | number)[][] = []
      const header = ['ラベル', '値', '割合']

      data.push(header)
      const totalData = this.trafficSource
        .map(follower => follower.count)
        .reduce((count, current) => count + current, 0)

      this.trafficSource.forEach(follower => {
        const percentage = !totalData ? 0 : Math.round((follower.count / totalData) * Math.pow(100, 2)) / 100
        data.push([follower.label, follower.count, percentage])
      })

      return { filename, data }
    }
  }
})
</script>
